import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-79bbecb4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "ColorHeightProjectionRenderContainer"
};
const _hoisted_2 = {
  class: "flex justify-center"
};
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "intro mt16"
}, " 下图是一个 3×3×3 网格正方体的高度图，黄色代表 0，红色代表 1，绿色代表 2，蓝色代表 3。 请根据箭头所示视角，选择该方向下正确的观察结果，旋转后相同也算正确。 ", -1));
const _hoisted_5 = {
  class: "legend-row"
};
const _hoisted_6 = {
  class: "question-layout"
};
const _hoisted_7 = {
  class: "question-panel"
};
const _hoisted_8 = {
  class: "arrow-wrap"
};
const _hoisted_9 = {
  class: "height-grid"
};
const _hoisted_10 = {
  class: "answer-panel"
};
const _hoisted_11 = {
  class: "option-grid"
};
const _hoisted_12 = ["disabled", "onClick"];
const _hoisted_13 = {
  class: "projection-grid"
};
const _hoisted_14 = {
  class: "option-label"
};
const _hoisted_15 = {
  key: 0,
  class: "review-block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]), _hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.legendItems, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.label,
      class: "legend-item"
    }, [_createElementVNode("span", {
      class: "legend-color",
      style: _normalizeStyle({
        backgroundColor: item.color
      })
    }, null, 4), _createElementVNode("span", null, _toDisplayString(item.label), 1)]);
  }), 128))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", {
    class: _normalizeClass(["arrow", $options.arrowClass])
  }, _toDisplayString($options.arrowText), 3)]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.heights, (row, rowIndex) => {
    return _openBlock(), _createElementBlock("div", {
      key: `q_row_${rowIndex}`,
      class: "height-row"
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, colIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: `q_cell_${rowIndex}_${colIndex}`,
        class: "height-cell",
        style: _normalizeStyle({
          backgroundColor: $options.heightColor(cell)
        })
      }, null, 4);
    }), 128))]);
  }), 128))])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options, (option, index) => {
    return _openBlock(), _createElementBlock("button", {
      key: option,
      type: "button",
      class: _normalizeClass(["option-card", $options.optionClass(option)]),
      disabled: $props.reviewMode,
      onClick: $event => $options.onChoose(option)
    }, [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.answers[index], (row, rowIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: `a_row_${index}_${rowIndex}`,
        class: "projection-row"
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, colIndex) => {
        return _openBlock(), _createElementBlock("div", {
          key: `a_cell_${index}_${rowIndex}_${colIndex}`,
          class: "projection-cell",
          style: _normalizeStyle({
            backgroundColor: cell === 1 ? '#9ca3af' : '#ffffff'
          })
        }, null, 4);
      }), 128))]);
    }), 128))]), _createElementVNode("div", _hoisted_14, _toDisplayString(option), 1)], 10, _hoisted_12);
  }), 128))])])]), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    style: _normalizeStyle({
      color: $props.review.result ? '#27ae60' : '#e74c3c'
    })
  }, "您的答案：" + _toDisplayString($props.review.answer || '未作答'), 5)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}